// Section 8: Hunter. 1.8 food and 0.2 cloth (hides); Winter 0.6x; 0.1 extra tool wear.
// Spear 1.6x; 6% injury, 2% death (4% at High threat). Constants: config.jobs.hunter.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { alwaysEligible, produced } from '../../core/content-helpers';
import { defineJob } from '../../core/registry';

export function hunter(config: Config) {
  const c = config.jobs.hunter;

  return defineJob({
    id: 'hunter',
    label: 'Hunter',
    section: 'S8',
    heavy: false,
    output: { kind: 'stock', resource: 'food' },
    baseYield: c.yield,
    toolFactor: c.toolFactor,
    toolWear: c.toolWear,
    risks: { injury: c.injury, death: c.death },
    riskIllness: null,
    requiresBuilding: null,
    minStrength: 0,
    modifierTargets: ['output', 'jobRisk'],
    modifierKeys: { output: ['hunter'], jobRisk: ['hunter'] },
    modifiers(ctx, target) {
      if (target.kind === 'output' && target.jobId === 'hunter' && ctx.season.season === 'winter') {
        return [mod.mul('job:hunter', c.winterFactor, 'winter')];
      }
      if (target.kind === 'jobRisk' && target.jobId === 'hunter' && target.risk === 'death') {
        return ctx.state.options.threatLevel === 'high'
          ? [mod.set('job:hunter', c.deathHighThreat, 'high threat')]
          : [];
      }
      return [];
    },
    produce(_ctx, _worker, output) {
      if (output <= 0) return [];
      return [produced('food', output), produced('cloth', (c.cloth * output) / c.yield)];
    },
    eligible: alwaysEligible,
  });
}
